import type { DirectiveBinding } from 'vue'

interface HTMLParentDiv extends HTMLDivElement {
  clickOutsideEvent?(event: Event): void
}

const vClickOutside = {
  mounted(el: HTMLParentDiv, binding: DirectiveBinding) {
    el.clickOutsideEvent = (event: Event): void => {
      //check that click was outside the el and its childrens
      if (!(el == event.target || el.contains(event.target as Node | null))) {
        binding.value()
      }
    }
    document.addEventListener('click', el.clickOutsideEvent)
  },
  unmounted(el: HTMLParentDiv) {
    document.removeEventListener(
      'click',
      el.clickOutsideEvent as (this: Document, ev: MouseEvent) => any
    )
  },
}

export default vClickOutside
